(function () {
  var p = window.__product;
  if (!p) return;
  var groups = document.querySelectorAll('.opt-group');
  var priceEl = document.getElementById('ProductPrice');
  var idEl = document.getElementById('VariantId');
  var btn = document.getElementById('AddToCart');
  function selected() {
    return Array.prototype.map.call(groups, function (g) {
      var s = g.querySelector('.opt-pill.selected');
      return s ? s.dataset.value : null;
    });
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function update() {
    var sel = selected();
    var v = p.variants.find(function (v) {
      return sel.every(function (val, i) { return v.options[i] === val; });
    });
    if (v) {
      idEl.value = v.id;
      priceEl.textContent = money(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.featured_image && v.featured_image.src) {
        var main = document.getElementById('MainImage');
        if (main) main.src = v.featured_image.src;
      }
    } else {
      btn.disabled = true;
      btn.textContent = 'Unavailable';
    }
  }
  groups.forEach(function (g) {
    g.querySelectorAll('.opt-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        g.querySelectorAll('.opt-pill').forEach(function (x) { x.classList.remove('selected'); });
        pill.classList.add('selected');
        update();
      });
    });
  });
  update();
})();
